import { useContext, useEffect, useState } from "react";
import { Avatar, Box, Button, Container, Paper, Rating, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import UserContext from "../../../navigation/context/userContext";
import { GetEventByID } from "../../../controllers/customer/EventosController";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import Review from "../../../components/review";
import QUDProgress from "../../../components/progress";
import { imagesURL } from "../../../apiRoutes/apiBase";

import FavoriteIcon from '@mui/icons-material/Favorite';

import caricaturaHorizontal from '../../../assets/images/ate/caricaturaHorizontal.jpg';
import caricaturaVertical from '../../../assets/images/ate/caricaturaVertical.jpg';
import logoate from '../../../assets/images/ate/logoate.png';
import SignInModal from "../../auth/signInModal";
import { review_create } from "../../../controllers/customer/ReviewsController";
import ResponseComponent from "../../../components/responseComponent";



const labels = {
    1: 'Terrible',
    2: 'Malo',
    3: 'Normal',
    4: 'Bueno',
    5: 'Genial',
  };
  
  function getLabelText(value) {
    return `${value} Star${value !== 1 ? 's' : ''}, ${labels[value]}`;
  }


export default function EventsReviewFeriaTurismo(){
    const { userData } = useContext(UserContext);
    const [value, setValue] = useState(5);
    const [hover, setHover] = useState(5);

    const [comment,setComment] = useState('');
    const [event,setEvent] = useState([]);
    const [openReview,setOpenReview] = useState(false);

    const [isLoading,setIsLoading] = useState(false);
    const [open,setOpen] = useState(false);
    const [success,setSuccess] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState();
    const [actionText,setActionText] = useState('');

    const [showModal,setShowModal] = useState(false);

    const { id } = useParams();
    
    const history = useHistory();

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const redireccionar = (route) => {
        history.push(route)
    }

    const calculateUser = () => {
        if(userData.user === undefined)
        {
            localStorage.setItem('openModalReview','true');
            setShowModal(true);
        }
    }
    

    useEffect(()=>{
        localStorage.setItem('openModalReviewEvent',true)
        handleGetEvent();
        handleReviewLocalStorage();
        /*if(userData.user !== undefined)
        {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }*/
        window.scrollTo(0,0);
    },[]);

    const handleGetEvent = async () => {
        setIsLoading(true);
        let response = await GetEventByID(id);
        if(response.success === true)
        {
            setEvent(response.data.event);
            //setTickets(response.data.tickets);
            //handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    }

    const handleReviewLocalStorage = () => {
        if(localStorage.getItem('openModalReviewEvent') === 'true')
            setOpenReview(true)
    }

    const handleCloseReview = () => {
        redireccionar(`/eventos/${id}`)
    }

    const handleOnClose = () => {
        localStorage.removeItem('openModalReview');
        setShowModal(false)
    }

    const handleSubmit = async () => {
        setIsLoading(true);
        let response = await review_create('event',event.uuid,value,comment);
        if(response.success === true)
        {
            setTitle('Operación Exitosa!');
            setSuccess(true);
            setMessage(response.message);
            setActionText('Finalizar');
            setOpen(true);

            setComment('');
            setValue(3);
            setHover(3);
        }
        else
        {
            setTitle('Operación Fallida!');
            setSuccess(false);
            setMessage(response.message);
            setActionText('Finalizar');
            setOpen(true);
        }
        setIsLoading(false);
    }

    return(
        
            <Box 
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    width: '100vw',
                }}
            >
                <Box
                    //component="img"
                    //src={isSmallScreen ? caricaturaVertical : caricaturaHorizontal}
                    alt="Imagen de fondo"
                    sx={{
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${isSmallScreen ? caricaturaVertical : caricaturaHorizontal})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        objectFit: 'cover',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    
                    <Paper elevation={4} sx={{padding:4,backgroundColor:'rgba(206, 232, 237, 0.8)',width:'80%',textAlign:'center'}}>
                        <Box sx={{display:'flex',flexDirection:'row',justifyContent:'center',mb:2}}>
                            <img
                                src={logoate}
                                alt="Anzoategui te enamora"
                                style={{ width: 120, height: 120, objectFit: 'contain' }}
                            />
                        </Box>
                        <Typography variant="h5" component="h1" color={'#2b3180'} gutterBottom fontWeight={'bold'}>
                            {event.nombre}
                        </Typography>
                        <Typography variant="h6" component="p" gutterBottom fontWeight={'bold'}>
                            ¡Tu opinión es muy importante para nosotros!
                        </Typography>
                        

                        {
                            userData.user !== undefined
                            ?
                            <>
                             <Typography variant="body1" component="p" gutterBottom >
                                En una escala del 1 al 5, donde 5 es "Genial", ¿cómo calificarías tu experiencia general en la feria?
                            </Typography>
                            <Box
                                sx={{
                                    width:'100%',
                                    display: 'flex',
                                    flexDirection:'column',
                                    justifyContent:'center',
                                    alignItems: 'center',
                                    mt:2,mb:2
                                }}
                            >
                                
                                <Rating
                                    name="hover-feedback"
                                    value={value}
                                    precision={1}
                                    sx={{fontSize:40}}
                                    getLabelText={getLabelText}
                                    onChange={(event, newValue) => {
                                        setValue(newValue);
                                    }}
                                    onChangeActive={(event, newHover) => {
                                        setHover(newHover);
                                    }}
                                    emptyIcon={<FavoriteIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                    icon={<FavoriteIcon fontSize="inherit" />}
                                />

                                {value !== null && (
                                    <Box >{labels[hover !== -1 ? hover : value]}</Box>
                                )}

                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="dense"
                                    id="comment"
                                    name="comment"
                                    label="Comentario (opcional)"
                                    value={comment}
                                    onChange={(e)=>setComment(e.target.value)}
                                />

                                {
                                    userData.user !== undefined &&
                                    <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',mt:2}}>
                                        <Button
                                            disabled={isLoading}
                                            variant="contained"
                                            color="cancel"
                                            onClick={()=>handleCloseReview()}
                                        >
                                            <Typography fontWeight={'bold'}>Cancelar</Typography>
                                        </Button>
                                        <Button
                                            disabled={isLoading}
                                            variant="contained"
                                            sx={{ml:2}}
                                            onClick={()=>handleSubmit()}
                                        >
                                            <Typography fontWeight={'bold'}>Reseñar</Typography>
                                        </Button>
                                    </Box>
                                }
                            </Box>
                            </>
                            :
                            <>
                            {/**<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Typography variant="body1" textAlign={'center'}>Para poder dejar una reseña debes iniciar sesión</Typography>
                                </Grid> */}

                                
                                    <Button variant="contained" fullWidth onClick={()=>calculateUser()}>
                                        <Typography fontWeight={'bold'}>Deja tu Reseña</Typography>
                                    </Button>
                            </>
                        }
                        
                    </Paper>
                </Box>

                <SignInModal
                    open={showModal}
                    onClose={()=>handleOnClose()}
                />

                <QUDProgress open={isLoading}/>
                <ResponseComponent
                    show={open}
                    success={success}
                    title={title}
                    message={message}
    
                    onClick={()=>handleCloseReview()}
                    actionText={actionText}
                />
                
            </Box>
            
    )
}